import styled from 'styled-components'

interface IProps {
  bold?: boolean
  textAlign?: string
}

const Title = styled('h1')<IProps>`
  color: ${({ theme }) => theme.colors.slate};
  font-size: 22px;
  font-weight: ${(props: IProps) => (props.bold ? '600' : '400')};
  margin: 0;
  text-align: ${(props: IProps) =>
    props.textAlign ? props.textAlign : 'unset'};
`

export default Title
